import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function counterNumbers() {
  const tickers = Array.from(document.querySelectorAll('.ticker'));

  tickers.forEach((ticker) => {
    const originalContent = ticker.textContent;
    const isThousandFormatted = originalContent.includes('.');
    // If the number is formatted with a period, we replace it to get the actual number to count to.
    const numericEndValue = isThousandFormatted ? parseInt(originalContent.replace(/\./g, ''), 10) : parseInt(originalContent, 10);

    // Create a tween for each ticker
    gsap.fromTo(ticker, {
      textContent: 0,
    }, {
      textContent: numericEndValue,
      duration: 2,
      ease: 'power1.in',
      snap: { textContent: 1 },
      onUpdate: function () {
        let currentNumericValue = this.targets()[0].textContent;
        // Format the number with periods as thousand separators only if the original content had it
        ticker.textContent = isThousandFormatted ? formatNumberWithPeriod(currentNumericValue) : currentNumericValue;
      },
      onComplete: function () {
        // Reset the original formatting
        ticker.textContent = originalContent;
        if (ticker.getAttribute('data-ticker-after')) {
          ticker.textContent += ticker.getAttribute('data-ticker-after');
        }
      },
      scrollTrigger: {
        trigger: ticker,
        toggleActions: 'play none none none'
      }
    });
  });
}

// Custom formatting function that adds period as thousand separator
function formatNumberWithPeriod(number) {
  // Split the number into groups of three and add periods, but only if it's long enough to warrant a separator
  if(number.length > 3) {
    let reversed = number.split('').reverse().join('');
    let groups = reversed.match(/.{1,3}/g);
    return groups.join('.').split('').reverse().join('');
  } else {
    return number;
  }
}

export { counterNumbers };